angular.module('impactx.basket').controller('BasketSupplierCtrl', [
    '$scope',
    '$mdDialog',
    'OpenGovernmentDataService',
    'dataGen',
    '$timeout',
    'AppConfiguration',
    'TranslationService',
    'ToastService',
    'LoadingDialogService',
    'BasketService',
    BasketSupplierCtrl]);

function BasketSupplierCtrl($scope, $mdDialog, OpenGovernmentDataService, dataGen, $timeout, AppConfiguration, TranslationService, ToastService, LoadingDialogService, BasketService) {
    var self = this;
    $scope.addressesLayout = AppConfiguration.get('basketAddressesLayout');
    $scope.controlsLayout = AppConfiguration.get('basketControlsLayout');
    $scope.datesLayout = AppConfiguration.get('basketDatesLayout');
    $scope.showBuyerNoMinimizedBasket = AppConfiguration.get('showBuyerNoMinimizedBasket');
    $scope.fictionalPriceLabel = TranslationService.get("fictionalPrice");
    $scope.servicePeriodOption = {};
    $scope.servicePeriodSelection = {selected: null};
    if ($scope.basketSupplierHeader.servicePeriod && $scope.basketSupplierHeader.servicePeriod.value)
    {
        $scope.servicePeriodSelection.selected = $scope.servicePeriodOption;
    }
    $scope.myDate = new Date();
    $scope.minDate = new Date(
        $scope.myDate.getFullYear(),
        $scope.myDate.getMonth(),
        $scope.myDate.getDate()
    );

    $scope.showAddresses = $scope.showAddresses || {};
    $scope.showControl = $scope.showControl || {};
    $scope.showDate = $scope.showDate || {};
    $scope.showComments = $scope.showComments || {};

    $scope.deleteBasketSupplierHeader = function () {
        //todo: own entry point? own list of deletion? this is not so good..
        while ($scope.selectedBasketItems.length > 0) {
            $scope.selectedBasketItems[0].selected = false;
            $scope.selectedBasketItems.splice(0, 1);
        }
        for (var i = 0; i < $scope.basketSupplierHeader.basketItemList.length; i++) {
            $scope.selectedBasketItems[i] = $scope.basketSupplierHeader.basketItemList[i];
        }
        $scope.deleteItems();
    };

    $scope.toggleExpressOrder = function () {
        $scope.saveBasket();
    };

    self.selectSupplier = function (event) {
        if (event.target.tagName != "MD-SELECT" &&
            (!event.target.parentNode.tagName || event.target.parentNode.tagName != "MD-SELECT-VALUE")
            && (!event.target.parentNode.tagName || !event.target.parentNode.parentNode.tagName || event.target.parentNode.parentNode.tagName != "MD-SELECT-VALUE")) {
            $scope.showAddresses.value = false;
            $scope.showControl.value = false;
            $scope.showDate.value = false;
            $scope.showComments.value = false;
            for (var i = 0; i < $scope.selectedBasketItems.length; i++) {
                $scope.selectedBasketItems[i].selected = false;
            }
            $scope.selectedBasketItems.length = 0;

            if ($scope.selectedBasketSupplier[0] !== $scope.basketSupplierHeader) {
                $scope.selectedBasketSupplier[0] = $scope.basketSupplierHeader;
            }
            else {
                $scope.selectedBasketSupplier.splice(0, 1);
            }
        }
    };

    self.changeOutlet = function (outletId, suppHeaderId) {
        $scope.changeOutlet({outletId: outletId, suppHeaderId: suppHeaderId});
    };

    self.changeAat = function (aatId, basketSupplierHeader, oldAATId) {
        if (oldAATId && impactX.isDefined(basketSupplierHeader, 'aat.entries')) {
            var oldAATSelected = undefined;
            for (var i = 0; i < basketSupplierHeader.aat.entries.length; i++) {
                if (basketSupplierHeader.aat.entries[i].id == oldAATId) {
                    oldAATSelected = basketSupplierHeader.aat.entries[i];
                    break;
                }
            }
            $scope.changeAat({aatId: aatId, basketSupplierHeader: basketSupplierHeader, oldAAT: oldAATSelected});
        }
        else {
            $scope.changeAat({aatId: aatId, basketSupplierHeader: basketSupplierHeader});
        }

    };

    self.checkAATSelected = function () {
        return impactX.isDefined($scope, 'basketSupplierHeader.aat.selected.id')
    };


    self.checkRequireAAT = function () {
        if ($scope.ignoreAccountingRequired) {
            return false;
        }
        var result = $scope.requireAat && impactX.isDefined($scope, 'basketSupplierHeader.aat.showMust');
        if (result) {
            for (var i = 0; i < $scope.basketSupplierHeader.basketItemList.length; i++) { // check the items
                var item = $scope.basketSupplierHeader.basketItemList[i];
                result = result && !impactX.isDefined(item, 'aat.selected.id');
            }
        }
        return result;
    };
    
    $scope.ctrlRequired = {};
    for(var key in $scope.basketSupplierHeader.control) {
        $scope.ctrlRequired[key] = $scope.basketSupplierHeader.control[key].showMust;
    }
    
    this.showControl = function(ctrl, type){
        return ctrl && (($scope.showControl.value && $scope.basketSupplierHeader === $scope.selectedBasketSupplier[0])
            || $scope.ctrlRequired[type] || (ctrl.set&&ctrl.set.length>0))
    };
    
    this.checkRequireCtrl = function(ctrlString){
        if($scope.ignoreAccountingRequired){
            $scope.ctrlRequired[ctrlString] = false;
        } else {
            $scope.ctrlRequired[ctrlString] = $scope.requireCtrl({ctrlString: ctrlString, basketSupplier: $scope.basketSupplierHeader});
        }
        return $scope.ctrlRequired[ctrlString];
    };

    self.changeAatItem = function (aatId, basketItem, oldAAT) {
        $scope.changeAatItem({aatId: aatId, basketItem: basketItem, oldAAT: oldAAT});
    };

    self.checkRequireCtrlItem = function (ctrlString, basketItem) {
        if ($scope.ignoreAccountingRequired) {
            return false;
        }
        return $scope.requireCtrlItem({
            ctrlString: ctrlString,
            basketItem: basketItem,
            basketSupplier: $scope.basketSupplierHeader
        });
    };

    self.openOpenGovernmentDialog = function (event, basketSupplierHeader) {
        var reportSPO = impactX.isDefined($scope, 'basketSupplierHeader.subsequentPurchaseOrderEnabled.value');
        OpenGovernmentDataService.openEditDialog(event, basketSupplierHeader.ogd.id, basketSupplierHeader.id, 0, 0, reportSPO).then(function (answer) {
            if (answer) {
                $scope.basketSupplierHeader.ogd.id = answer.ogdId;
                $scope.basketSupplierHeader.ogd.summary = answer.summary;
                $scope.basketSupplierHeader.ogd.isDirty = false;
                $scope.basketSupplierHeader.ogd.isInvalid = false;
                BasketService.validateSPO(basketSupplierHeader, true);
                $scope.errorListDirty.length = 0;
            }
        });
    };
    
    self.setOgdChanged = function(event) {
        if (!$scope.basketSupplierHeader.ogd.reportOGD.readOnly) {
            $scope.basketSupplierHeader.ogd.wasChanged = true;

            // Negation of reportOGD is used because the change hasn't happened yet
            if (!$scope.basketSupplierHeader.ogd.id && !$scope.basketSupplierHeader.ogd.reportOGD.value) {
                self.openOpenGovernmentDialog(event, $scope.basketSupplierHeader);
            }
            else {
                BasketService.validateOGD($scope.basketSupplierHeader, true, !$scope.basketSupplierHeader.ogd.reportOGD.value);
            }
            if ($scope.basketSupplierHeader.ogd.reportOGD.value == true)
            {
                BasketService.validateSPO($scope.basketSupplierHeader, true);
            }
        }
    };

    self.enterServicePeriod = function (event) {
        $mdDialog.show({
            controller: "ServicePeriodCtrl",
            controllerAs: "servicePeriodCtrl",
            templateUrl: "modules/basket/templates/serviceperiod.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                servicePeriod: $scope.basketSupplierHeader.servicePeriod,
                readOnly: $scope.readOnly
            }
        }).then(function (servicePeriod) {
            $scope.basketSupplierHeader.servicePeriod.startDate = servicePeriod.startDate;
            $scope.basketSupplierHeader.servicePeriod.endDate = servicePeriod.endDate;
            $scope.basketSupplierHeader.servicePeriod.runTime = servicePeriod.runTime;
            $scope.basketSupplierHeader.servicePeriod.serviceContractor = servicePeriod.serviceContractor;
            $scope.basketSupplierHeader.servicePeriod.value = " ";
            $timeout(function() {
                if ($scope.basketSupplierHeader.servicePeriod.value === " ")
                {
                    $scope.basketSupplierHeader.servicePeriod.value = $scope.trns.loading;
                }
            }, 500);
            $scope.servicePeriodSelection.selected = $scope.servicePeriodOption;

            dataGen.getData({}, {servicePeriod: $scope.basketSupplierHeader.servicePeriod}, "/basket/servicecontract/valuestring").then(function (data) {
                $scope.basketSupplierHeader.servicePeriod.value = data.data.value;
            });
        }, function (doDelete) {
            if (doDelete)
            {
                $scope.basketSupplierHeader.servicePeriod.startDate.dateValue = null;
                $scope.basketSupplierHeader.servicePeriod.endDate.dateValue = null;
                $scope.basketSupplierHeader.servicePeriod.runTime.value = 0;
                $scope.basketSupplierHeader.servicePeriod.serviceContractor.value = "";
                $scope.basketSupplierHeader.servicePeriod.value = "";
                $scope.servicePeriodSelection.selected = null;
            }
        });
    };

    self.anyControlSet = function () {
        if($scope.basketSupplierHeader.aat && $scope.basketSupplierHeader.aat.selected) {
            return true
        }
        var ctrl = $scope.basketSupplierHeader.control;
        for(var key in ctrl) {
            if(ctrl.hasOwnProperty(key) && ctrl[key].set && ctrl[key].set.length > 0) {
                return true;
            }
        }
        return false;
    }

    self.openSubsequentPurchaseOrderInfoDialog = function($event, enableSPO) {
        var spoEnabled = enableSPO || impactX.isDefined($scope, "basketSupplierHeader.subsequentPurchaseOrderEnabled.value");
        $mdDialog.show({
            controller: 'EditSPOCtrl',
            controllerAs: 'spoInfoCtrl',
            templateUrl: 'modules/subsequentpurchaseorderdata/templates/subsequent-purchase-order-info-dialog.html',
            parent: angular.element(document.body),
            targetEvent: $event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                id: $scope.basketSupplierHeader.id,
                type: 'bks',
                reportOGD: impactX.isDefined($scope, 'basketSupplierHeader.ogd.reportOGD.value'),
                hasSPOEnabled: spoEnabled
            }
        }).then(function (answer) {
            if (answer) {
                BasketService.validateOGD($scope.basketSupplierHeader, true);
                if(answer.data.ogdInvalid && $scope.basketSupplierHeader.ogd)
                {
                    $scope.basketSupplierHeader.ogd.isInvalid = true;
                    $scope.basketSupplierHeader.ogd.isDirty = true;
                    $scope.errorListDirty.push($scope.trns.position + " " +  $scope.basketSupplierHeader.contractName +" (" + $scope.basketSupplierHeader.contractNo +"): "+ $scope.trns.errorDirty);
                }
                $scope.basketSupplierHeader.spoInfoId = answer.data.spoInfoId;
            }
        });
    }

    self.reportSPOChanged = function (basketSupplierHeader) {
        var reportOGD = impactX.isDefined(basketSupplierHeader, 'ogd.reportOGD.value');
        var reportSPO = impactX.isDefined(basketSupplierHeader, 'subsequentPurchaseOrderEnabled.value');

        if (reportOGD && !reportSPO) {
            return dataGen.getData({}, {bksId: basketSupplierHeader.id}, "/opengovernmentdata/report/initbytender").then(function () {
                basketSupplierHeader.ogd.isDirty = true;
                $scope.errorListDirty.push($scope.trns.position + " " +  $scope.basketSupplierHeader.contractName +" (" + $scope.basketSupplierHeader.contractNo +"): "+ $scope.trns.errorDirty);

            });
        }
        if($scope.basketSupplierHeader.subsequentPurchaseOrderEnabled.value == false)
        {
            BasketService.validateSPO($scope.basketSupplierHeader, true);
        }
    }

    $scope.initControlWatch = function () {
        for (var key in $scope.basketSupplierHeader.control) {
            if(impactX.isObject($scope.basketSupplierHeader.control[key])) {
                const watchedControl = "basketSupplierHeader.control['" + key + "'].set";
                const labelKey = key;
                $scope.$watchCollection(watchedControl, function (newVal) {
                    if(newVal.length > 0) {
                        $scope.hasControlLabels[labelKey] = " (" + $scope.trns.parentHasControl + ")";
                    }
                    else {
                        $scope.hasControlLabels[labelKey] = undefined;
                    }
                });
            }
        }
    }

    $scope.clearDates = function () {
        $scope.basketSupplierHeader.requestedDeliveryDates.forEach(function (dateObj) {
            dateObj.dateValue = null;
            dateObj.startHour = null;
            dateObj.endHour = null;
        });
    }

    this.updateFileSize = function () {
        if ($scope.basketSupplierHeader.fileSize) {
            dataGen.getData({}, {bksId: $scope.basketSupplierHeader.id}, "/basket/bks/filesize").then(function (data) {
                $scope.basketSupplierHeader.fileSize = data.data;
            });
        }
    }

    this.addStatusEmailAddress = function (emailValue) {
        LoadingDialogService.start();
        var dataObj = {
            id: $scope.basketSupplierHeader.id,
            mail: emailValue
        };
        dataGen.postAsForm({}, dataObj, '/basket/statusmailaddress/supplier/add').then(function () {
                LoadingDialogService.stop();
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            },
            function () {
                LoadingDialogService.stop();
                $scope.basketSupplierHeader.statusEMailAddresses.pop();
            });
    }

    this.deleteStatusEmailAddress = function (emailValue) {
        LoadingDialogService.start();
        var dataObj = {
            id: $scope.basketSupplierHeader.id,
            mail: emailValue
        };
        dataGen.postAsForm({}, dataObj, '/basket/statusmailaddress/supplier/delete').then(function () {
                LoadingDialogService.stop();
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            },
            function () {
                LoadingDialogService.stop();
                $scope.basketSupplierHeader.statusEMailAddresses.push(emailValue);
            });
    }
    $scope.initControlWatch();

    this.hasRDDateDefinedOrRequired = function () {
        return $scope.basketSupplierHeader.requestedDeliveryDates && (($scope.basketSupplierHeader.allowDistributionList && !$scope.disableSendDistribListCheckbox) ||
            $scope.basketSupplierHeader.requestedDeliveryDates.some((item)=>{
            return item.dateValue || item.showMust;
        }));
    }

    this.changeTimeframe = function(rdd, selected) {
        rdd.start.dateValue = selected.start.dateValue;
        rdd.end.dateValue = selected.end.dateValue;
    }
}
